import Cid10List, { Cid10, Cid10DadosBeneficiario } from './Cid10List';

export type { Cid10, Cid10DadosBeneficiario };

export default Cid10List;
